
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { memorandumTypes } from "@/constants/documentTypes"

interface MemorandumFieldsProps {
  recipient: string
  memorandumType?: string
  onChange: (field: string, value: string) => void
}

export function MemorandumFields({ recipient, memorandumType, onChange }: MemorandumFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Tipo de Memorando
        </Label>
        <Select
          value={memorandumType}
          onValueChange={(value) => onChange("memorandumType", value)}
          required
        >
          <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
            <SelectValue placeholder="Selecione o tipo de memorando" />
          </SelectTrigger>
          <SelectContent className="max-h-[200px] overflow-y-auto">
            {memorandumTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="recipient" className="text-sm font-medium text-gray-700">
          Destinatário
        </Label>
        <Input
          id="recipient"
          value={recipient}
          onChange={(e) => onChange("recipient", e.target.value)}
          className="border-gray-200 focus:ring-primary/20"
          placeholder="Digite o nome do destinatário"
        />
      </div>
    </>
  )
}
